module.exports = __webpack_public_path__ + "img/Topup-2.047a9f78.svg";